// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1i4Hh","footer":"ChangeClinic_footer__o1-nu"};